import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { User } from '../../gql/graphql';

interface AdvancedTabProps {
	userData: Partial<User>;
	updateUserData: (updates: Partial<User>) => void;
}

function AdvancedTab({ userData, updateUserData }: AdvancedTabProps) {
	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Advanced Settings
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Additional user information and metadata
			</Typography>

			<Grid container spacing={3}>
				{/* User ID */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="User ID"
						name="_id"
						value={userData._id || 'Auto-generated after save'}
						disabled
						helperText="Unique identifier for this user"
					/>
				</Grid>

				{/* Future Custom Fields */}
				<Grid item xs={12}>
					<Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Additional custom fields such as access logs, session information, and preferences can be added here in future updates.
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AdvancedTab;
